<template>
	<div class="marketingManagement-body">
		<div class="fx-header">
			<p>会员卡管理</p>
		</div>
		<Search @getTableData="getTableDataHandle" @getParamsData="getParamsData"></Search>
		<div class="btn-box1">
			<div style="min-height:60px;display :flex;align-items :center">
				<el-button
					type="primary"
					size="small "
					v-if="AuthorityList['08_0005_0003_00']"
					@click="addClick"
					icon="el-icon-plus"
					>新增卡型
				</el-button>
				<el-button
					type="primary"
					class="search-btn fx-big-btn"
					size="small "
					v-if="AuthorityList['08_0005_0004_00']"
					@click="delClick(true)"
					plain>删除
				</el-button>
			</div>
        </div>
		<div class="main-table-box">
			<el-table
			:stripe='true'
			size='mini'
			class="grid-content"
			@row-dblclick='rowClick'
			:data="tableData"
			:height="tableHeight"
			border
			@selection-change="handleSelectionChange"
			ref="table">
			<el-table-column
			type="selection"
			align="center"
			fixed="left"
			width="50">
			</el-table-column>
			<el-table-column
				prop="name"
				key="name"
				label="会员卡名称"
				align="center"
				min-width="200">
				<template slot-scope='scope'>
					<el-tooltip placement="top">
						<div slot="content">{{scope.row.name}}</div>
						<div class="rule-box">{{scope.row.name}}</div>
					</el-tooltip>
					<div>编号：{{scope.row.code}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="促销方式、内容"
				align="center"
				min-width="300">
				<template slot-scope='scope'>
					<div>
						<!-- {{scope.row.discountcondition === 0 ? '无门槛' : '满'}}
						{{scope.row.discountcondition === 1 ? scope.row.needmoney : ''}} -->
						<span v-if="scope.row.discountrule === 0">折扣 - {{scope.row.salecount}}折</span>
						<span v-if="scope.row.discountrule === 1">立减 - {{scope.row.discountmoney}}元</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="createdate"
				key="createdate"
				label="创建时间"
				align="center"
				min-width="200">
			</el-table-column>
			<el-table-column
				prop="customerlevels"
				label="适用会员等级"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div v-if="scope.row.customerlevelattendway === 0">全部等级</div>
					<div v-if="scope.row.customerlevelattendway === 1">{{scope.row.customerlevels}}</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="customercount"
				label="客户数量"
				align="center"
				min-width="150">
			</el-table-column>
			<el-table-column
				label="适用商品分类"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div>{{scope.row.productattendway === 0 ? '全部商品' : '部分商品'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用店铺"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div>{{scope.row.shopattendway === 0 ? '全部店铺' : '部分店铺'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="状态"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div v-if="scope.row.discountState === 1" style="color:#f0902a">未生效</div>
					<div v-if="scope.row.discountState === 0" style="color:#64b448">生效中</div>
					<div v-if="scope.row.discountState === 2" style="color:#4899ff">已失效</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="countcoupon"
				label="生效时间"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div v-if="scope.row.discountdatetype === 0">不限时间</div>
					<div v-if="scope.row.discountdatetype === 1">{{scope.row.beginDate}}</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="usedcoupon"
				label="失效时间"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div v-if="scope.row.discountdatetype === 0">不限时间</div>
					<div v-if="scope.row.discountdatetype === 1">{{scope.row.endDate}}</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="200" align="center">
				<template slot-scope="scope">
					<el-button  type='text' size="mini" icon="el-icon-edit" v-if="AuthorityList['08_0005_0002_00']" @click='modifyClick(scope.row)'>编辑</el-button>
					<el-button  type='text' size="mini" icon="el-icon-delete" v-if="AuthorityList['08_0005_0004_00']" @click='delClick(false,scope.row)'>删除</el-button>
				</template>
			</el-table-column>
			</el-table>
		</div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.number"
            :page-sizes="[20, 40, 60, 100, 300]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="600px">
			<div style="width: 100%;max-height: 300px;overflow-y:auto;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					{{item}}
				</div>
				<div style="padding: 5px 10px;text-align: left;">以上优惠券不可删除，仅支持强制结束</div>
			</div>
			<div style="text-align:center" slot="footer">
				<el-button type="primary" size="mini" @click="closeError">知道了</el-button>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import Search from '@/components/vipList/Search.vue'
export default {
	name: 'vipList',
	components: {
		Search
	},
	data () {
		return {
			discountState: -1,
			AuthorityList: {
				'08_0005_0001_00': false,
				'08_0005_0002_00': false,
				'08_0005_0003_00': false,
				'08_0005_0004_00': false
			},
			keyword: '',
			tableData: [],
			tableHeight: '100%',
			total: 0,
			ids: [],
			page: {
				number: 1,
				size: 20
			},
			showError: false,
			errorList: []
		}
	},
	created () {
		this.tableReload()
		this.getAuthority('08_0005_0000_00')
	},
	methods: {
		closeError () {
			this.showError = false
		},
		delClick (flag, row) {
			if (flag) {
				if (this.ids.length === 0) {
					this.$message.error('至少选则一条活动')
					return false
				}
			}
			this.$confirm('确认删除会员卡型吗？删除后客户的会员等级自动修改 未设置', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let list = this.ids.map(item => {
					return item.id
				})
				let logger = null
				let name = ''
				if (flag) {
					let arr = []
					this.ids.forEach(item => {
						let name = '【' + item.code + '】' + '【' + item.name + '】'
						arr.push(name)
					})
					name = arr.join(',')
				} else {
					name = '【' + row.code + '】' + '【' + row.name + '】'
				}
				logger = this.$fxLogger.createInfo('discount.vip_info.delete', { name: name })
				let params = {
					discountids: flag ? list.join(',') : row.id,
					type: 3
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/shop/discount/delete`,
					data: params,
					logger
				}).then(res => {
					if (!res.result) {
						this.errorList = []
						this.errorList = res.data
						this.showError = true
						return false
					} else {
						this.$message.success('删除成功！')
						this.tableReload()
					}
				})
			}).catch(() => {
				this.$message.success('取消成功！')
			})
		},
		handleSelectionChange (val) {
			this.ids = val
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		addClick () {
			window.sessionStorage.removeItem('vipId')
			this.$router.push('vipDetail')
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		modifyClick (row, flag) {
			window.sessionStorage.setItem('vipId', row.id)
			this.$router.push('vipDetail')
		},
		getTableDataHandle (data) {
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		getParamsData (data) {
			this.page.number = data.page
			this.page.size = data.size
			this.discountState = data.discountState
			this.keyword = data.keyword
		},

		tableReload () {
			let params = {
				discountState: this.discountState,
				keyword: this.keyword,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/card/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.total = res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.marketingManagement-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.btn-box1{
		justify-content: space-between;
		display: flex;
		align-items: center
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
	.rule-box{
		width:100%;
		text-align:center;
		padding: 0 10px;
		overflow :hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.marketingManagement-body {
	.cell{
		padding :0px !important
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
		}
	}
	.showPicDialog{
		.el-dialog__header {
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
		}
	}
	.customerDialog{
		.el-dialog__header {
			margin :0px 20px;
			padding :10px 0px;
			border-bottom:1px solid #eee;
			text-align: left;
		}
		.el-dialog__body{
			padding: 10px 20px 10px 20px;
		}
		.name-input .el-input-group__append{
			background-color:var(--fx-primary-color);
			color:#FFFFFF
		}
	}
	.subordinateDialog{
		.el-dialog__body{
			padding :0px 20px;
		}
		.el-dialog__header {
			display :none
		}
		.blue-line{
			height :20px;
			width: 5px;
			background-color :var(--fx-primary-color);
			margin-right :10px;
		}
		.title{
			font-size:16px;
			justify-content: space-between;
			font-weight: bold;
			display :flex;
			flex-direction :row;
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
			margin-bottom :5px;
			.close{
				cursor: pointer;
				width: 20px;
				height: 20px;
				display :flex;
				align-items :center;
				justify-content :center;
				color :white;
				border-radius: 50%;
				background-color: #f00;
				line-height: 21px;
				font-weight: bold;
			}
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.alert-dialog{
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
			float : left !important;
		}
		.el-dialog__body{
			padding:20px 20px 20px 20px
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: #FFFFFF !important;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:black !important;
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}


}
</style>
